/**
 * @generated SignedSource<<68befc7ba55ed466263ddd12de2f460c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSidebar_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "UserSidebar_user";
};
export type UserSidebar_user$key = {
  readonly " $data"?: UserSidebar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSidebar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSidebar_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "101ed4ee19d8f3259af64c3a0163bc00";

export default node;
